import { apiService } from "./api.service";

export interface SetupTwoFactorResponse {
  success: boolean;
  message: string;
  data: {
    secret: string;
    qrCode: string;
    backupCodes: string[];
    message: string;
  };
}

export interface VerifyTwoFactorResponse {
  success: boolean;
  message: string;
  data: {
    twoFactorEnabled: boolean;
    backupCodes: string[];
    message: string;
  };
}

export interface TwoFactorStatusResponse {
  success: boolean;
  data: {
    twoFactorEnabled: boolean;
    twoFactorSetupCompleted: boolean;
    message: string;
    backupCodes?: Array<{
      code: string;
      isUsed: boolean;
    }>;
  };
}

class TwoFactorService {
  async setupTwoFactor(userId: number): Promise<SetupTwoFactorResponse> {
    return apiService.post<SetupTwoFactorResponse>(
      `/two-factor/setup/${userId}`
    );
  }

  async verifyTwoFactorSetup(
    userId: number,
    twoFactorCode: string
  ): Promise<VerifyTwoFactorResponse> {
    return apiService.post<VerifyTwoFactorResponse>(
      `/two-factor/verify-setup/${userId}`,
      { twoFactorCode }
    );
  }

  async disableTwoFactor(
    userId: number,
    twoFactorCode: string
  ): Promise<{ success: boolean; message: string; data: any }> {
    return apiService.post(`/two-factor/disable/${userId}`, {
      twoFactorCode,
    });
  }

  async getTwoFactorStatus(
    userId: number
  ): Promise<TwoFactorStatusResponse> {
    return apiService.get<TwoFactorStatusResponse>(
      `/two-factor/status/${userId}`
    );
  }

  async verifyBackupCode(
    userId: number,
    backupCode: string
  ): Promise<{ success: boolean; message: string; data: any }> {
    return apiService.post(`/two-factor/verify-backup/${userId}`, {
      backupCode,
    });
  }

  async verifyTwoFactorLogin(
    userId: number,
    twoFactorCode: string
  ): Promise<{ success: boolean; message: string; data: { token: string; user: any } }> {
    return apiService.post("/auth/verify-2fa-login", {
      userId,
      twoFactorCode,
    });
  }
}

export const twoFactorService = new TwoFactorService();
